import type { AsrRetrieveTranscriptionResponse } from '../api/types';

export const getProviderTranscriptId = (response: AsrRetrieveTranscriptionResponse): string =>
  response.execution?.attempts.at(-1)?.providerTranscriptId ??
  response.transcript?.provenance?.providerTranscriptId ??
  '';
